import React from 'react';
// Utils
import { getRoleName, validArray } from 'utils';
// Context
import { useAuthState } from 'context/AuthContext';
// Components
import { LinkCard } from 'elements/Cards';
import CardSet from 'elements/CardSet';
import PageHeader from 'components/PageHeader';

function Home() {
  const { defaultOrganisation } = useAuthState();
  const { roles } = defaultOrganisation || [];
  /* const {
    employee: {
      firstName,
    },
  } = useAuthState(); */
  const appPermissions = validArray(roles) ? roles.map(getRoleName) : [];
  return (
    <>
      <PageHeader heading="Welcome to My Order Workspace" />
      <section className="wrapper">
        <div className="wrapper__content">
          <CardSet>
            {appPermissions.includes('PLANNING ADMIN') && (
              <LinkCard href="/user-admin" icon="User" label="User Admin" />
            )}
            {(appPermissions.includes('PLANNING') || appPermissions.includes('PLANNING ADMIN') || appPermissions.includes('WAREHOUSE')) && (
            <LinkCard href="/dispatcher" icon="TruckCheck" label="Sales Order Processing" />
            )}
            {(appPermissions.includes('MASTER DATA') || appPermissions.includes('PLANNING') || appPermissions.includes('WAREHOUSE') || appPermissions.includes('PLANNING ADMIN')) && (
            <LinkCard href="/event-log" icon="EventLog" label="Event Log" />
            )}
            {(appPermissions.includes('PLANNING')) && (
            <LinkCard href="/pack-site" icon="PackSite" label="Site Order Fulfilment Tool " />
            )}
            {appPermissions.includes('PLANNING') && (
            <LinkCard href="/sales-order" icon="EventLog" label="View Sales Orders" />
            )}
            {appPermissions.length === 0 && (
              <h1 className="display6">Please select organisation unit to proceed</h1>
            )}
          </CardSet>
        </div>
      </section>
    </>
  );
}

export default Home;
